import { useState } from "react";
import { AdminShipmentWithLatestStatusModel } from "../apiModels/adminShipmentWithLatestStatusModel";
import { ShipmentUpdateModel } from "../apiModels/shipmentUpdateModel";
import { ShipmentDetailsModalStatus } from "../appConstants";
import { formatNullableString, toNullableLocaleDateTimeString } from "../utilities";
import ShipmentUpdateCreateModal from "./ShipmentUpdateCreateModal";
import ShipmentUpdateHistoryTable from "./ShipmentUpdateHistoryTable";
import ProofOfDeliveryRequestModal from "./ProofOfDeliveryRequestModal";
import ProofOfDeliveryRequestTable from "./ProofOfDeliveryRequestTable";

export default function ShipmentDetailsForm(props: { 
    shipment: AdminShipmentWithLatestStatusModel;
    loadShipment: () => void;
    canEdit: boolean;
}) {
    const shipment = props.shipment;
    
    const [showUpdateCreateModal, setShowUpdateCreateModal] = useState<boolean>(false);

    return (<>
        <div className='row'>
            <div className="col-6">
                <label className="form-label fw-bold">Tracking Number</label>
                <p>{shipment.trackingNumber}</p>
            </div>
            <div className="col-6">
                <label className="form-label fw-bold">Memo</label>
                <p>{formatNullableString(shipment.memo)}</p>
            </div>
        </div>
        {
            shipment.latestStatus && <>
                <div className='row'>
                    <h4 className='col-12 mt-2'>Latest Update</h4>
                </div>
                <div className='row'>
                    <div className="col-6">
                        <label className="form-label fw-bold">Status</label>
                        <p>{formatNullableString(shipment.latestStatus.shipmentStatus)}</p>
                    </div>
                    <div className="col-6">
                        <label className="form-label fw-bold">Date Created</label>
                        <p>{toNullableLocaleDateTimeString(props.shipment.latestStatus?.updateTime)}</p>
                    </div>
                </div>
                <div className='row'>
                    <div className="col-6">
                        <label className="form-label fw-bold">Latest Description</label>
                        <p>{formatNullableString(shipment.latestStatus.description)}</p>
                    </div>
                    <div className="col-6">
                        <label className="form-label fw-bold">Latest Location</label>
                        <p>{formatNullableString(shipment.latestStatus.location)}</p>
                    </div>
                </div>
            </>
        }
        <div className='row'>
            <h4 className='col-9 mt-2'>Update History</h4>
            {props.canEdit &&
            <div className='col-3 text-end'>
                <button className='btn btn-primary' onClick={() => setShowUpdateCreateModal(true)}>
                    <i className='bi bi-plus-lg me-2'></i>
                    Add Update
                </button>
            </div>}
        </div>
        <ShipmentUpdateHistoryTable shipmentTrackingNumber={shipment.trackingNumber}
            reloadShipment={props.loadShipment}
            canEdit={props.canEdit} />
        
        <div className='row'>
            <h4 className='col-9 mt-2'>Proof Of Delivery Requests</h4>
            <div className='col-3 text-end' />
        </div>
        <ProofOfDeliveryRequestTable shipmentTrackingNumber={shipment.trackingNumber} />
        
        <ShipmentUpdateCreateModal show={showUpdateCreateModal} 
            setShow={setShowUpdateCreateModal} 
            shipmentTrackingNumber={shipment.trackingNumber}
            mostRecentStatusId={shipment.latestStatus?.shipmentStatusId}
            postSaveActions={props.loadShipment} />
    </>)
}